<template>
  <div class="ebmp_box_privacy">
    <div class="title">소중한 <span class="forg">개인정보!</span><br />
      비밀번호를 변경하여 지켜주세요.</div>
    <span class="k-icon k-i-lock title_img"></span>
    <div class="txt_small">3개월 동안 비밀번호를 변경하지 않으셨네요!<br />
      조금 불편하시더라도 지금 비밀번호를 변경하시면<br />개인정보 피해를 막을 수 있습니다.</div>
    <ul class="filter_list">
      <li>
        <dl class="w100">
          <dt>현재 비밀번호</dt>
          <dd class="w100">
            <div class="f_r w30">
            </div>
            <span class="k-widget k-maskedtextbox w100">
<!--                  <input type="hidden">-->
                  <span class="k-widget k-maskedtextbox" style="width: 100%;">
                    <kendo-maskedtextbox
                        name=""
                        :type="'password'"
                        v-model="userPwd"
                        maxlength="50"
                        placeholder="현재 비밀번호를 입력해 주세요."
                        class="w100"
                        autocomplete="off"
                        :style="'width: 100%;'"></kendo-maskedtextbox>
                    <span class="k-icon k-i-warning"></span>
                  </span>
                  <span class="k-icon k-i-warning"></span>
            </span>
          </dd>
        </dl>
      </li>
      <li class="w100">
        <dl class="w100">
          <dt>새 비밀번호 입력</dt>
          <dd class="w100">
            <span class="k-widget k-maskedtextbox w100">
              <span class="k-widget k-maskedtextbox w100" style="width: 100%;">
                <!-- input으로 실시간 값 변화 감지 가능 -->
                <input
                    name=""
                    class="w100 k-textbox"
                    maxlength="50"
                    type="password"
                    autocomplete="off"
                    placeholder="새 비밀번호를 입력해 주세요."
                    v-model="newUserPwd"
                >
                <span class="k-icon k-i-warning"></span>
              </span>
              <span class="k-icon k-i-warning"> </span>
            </span>
            <div class="msg_area">
              <span v-show="isValid" class="msg_green">조건에 일치하는 비밀번호입니다.</span>
              <span v-show="isValid === false" class="msg_red">조건에 일치하지 않는 비밀번호입니다.</span>
            </div>
          </dd>
        </dl>
      </li>
      <li class="w100">
        <dl class="w100">
          <dt>새 비밀번호 확인</dt>
          <dd class="w100">
            <span class="k-widget k-maskedtextbox w100">
              <span class="k-widget k-maskedtextbox w100" style="width: 100%;">
                <kendo-maskedtextbox
                    name=""
                    :type="'password'"
                    v-model="newUserPwdConfirm"
                    placeholder="새 비밀번호를 한번 더 입력해 주세요."
                    class="w100"
                    autocomplete="off"
                    :style="'width: 100%;'"></kendo-maskedtextbox>
                <span class="k-icon k-i-warning"></span>
              </span>
              <span class="k-icon k-i-warning"></span>
            </span>
            <div class="msg_area">
              <span v-show="isCorrect" class="msg_green">새 비밀번호와 일치합니다.</span>
              <span v-show="isCorrect === false" class="msg_red">새 비밀번호와 일치하지 않습니다.</span>
            </div>
          </dd>
        </dl>
      </li>
    </ul>
    <div class="info_txt">
      ※ 비밀번호는 영문, 숫자, 특수기호를 혼합한 8~50자리로 설정이 가능합니다.<br />
      ※ 기존에 사용하셨던 비밀번호는 사용하실 수 없습니다.
    </div>
    <div class="box_btn">
      <button type="submit" class="large_btn orange" @click="onClickSave(true)">네, 지금 변경 할래요.</button>
      <button type="submit" id="duplicateSubmit" class="large_btn mgl10" @click="onClickSave(false)">아니오. 다음에 변경 할래요.(3개월)</button>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import ApiUtil from '@/api/api.util'
import ApiConfig from '@/api/api.config'
import EtnersPasswordUtil from '@/common/etners.password.util'
import EtnersEncDecUtil from '@/common/etners.encDec.util'

export default {
  name: 'ChangePW',
  watch: {
    'newUserPwd' : 'watchPwd',
    'newUserPwdConfirm' : 'watchPwd',
  },
  data: function () {
    return {
      userId : this.$route.params.userId,
      userPwd : this.$route.params.userPwd,
      newUserPwd : null,
      newUserPwdConfirm : null,

      isValid : null,
      isCorrect : null,
    }
  },
  async mounted () {
    const vm = this
    // 공개키 요청
    const publicKey = await EtnersEncDecUtil.getRSA()
    vm.publicKey = publicKey
  },
  methods: {
    watchPwd: function (e){
      const vm = this
      const newUserPwd = vm.newUserPwd
      const newUserPwdConfirm = vm.newUserPwdConfirm

      // 비밀번호 조건 만족 -> isValid
      // 비밀번호 일치 -> isCorrect

      if(!EtnersPasswordUtil.spacePwd(newUserPwd) && !EtnersPasswordUtil.combinationPwd(newUserPwd)){
        vm.isValid = true
      }else{
        vm.isValid = false
      }
      if(vm.isValid && newUserPwdConfirm !== null) {
        if (newUserPwd === newUserPwdConfirm) {
          vm.isCorrect = true
        }else{
          vm.isCorrect = false
        }
      }
    },

    // 비밀번호 변경
    onClickSave: async function (changeNow) {
      const vm = this
      const userId = vm.userId
      const userPwd = vm.userPwd
      const newUserPwd = vm.newUserPwd
      const newUserPwdConfirm = vm.newUserPwdConfirm

      // check list
      // 1. 현재 비밀번호 입력 여부
      // 2. 지금 변경 === 'Y'
      //   1. 새 비밀번호 입력 여부
      //   1. 새 비밀번호 === 새 비밀번호 확인
      //   2. 새 비밀번호 : 영문, 숫자, 특수기호를 혼합한 8~50자리

      if (userPwd == undefined || !userPwd) {
        kendo.alert('현재 비밀번호를 입력해 주세요.')
        return
      }

      let confirmMsg = '다음에 변경하시겠습니까?'
      if (changeNow) {
        confirmMsg = '비밀번호를 변경하시겠습니까?'
      }

      if (changeNow === true) {
        const value = EtnersPasswordUtil.validation(newUserPwd, newUserPwdConfirm)
        if (!value) {
          return
        }
      }

      /** 파라미터 암호화 **/
      const publicKey = vm.$store.state.encStoreModule.enc.data
      let userIdRSA = await EtnersEncDecUtil.encryptRSA(userId, publicKey)
      let userPwdRSA = await EtnersEncDecUtil.encryptRSA(userPwd, publicKey)

      let newUserPwdRSA = ''
      let newUserPwdConfirmRSA = ''
      if (changeNow) {
        newUserPwdConfirmRSA = await EtnersEncDecUtil.encryptRSA(newUserPwdConfirm, publicKey)
        newUserPwdRSA = await EtnersEncDecUtil.encryptRSA(newUserPwd, publicKey)
      }

      const params = {
        "userId": userIdRSA,
        "userPwd": userPwdRSA,
        "newUserPwd": newUserPwdRSA,
        "newUserPwdConfirm": newUserPwdConfirmRSA,
        "changeNow": changeNow ? 'Y' : 'N',
      }

      kendo.confirm(confirmMsg).done(function () {
        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/account/changePW.json`

        ApiUtil.post(url, params).then(async response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
            return false
          }
          if (response.data.resultStatus.messageCode !== '2000') {
            kendo.alert(response.data.resultStatus.messageText)
            return false
          }

          // 비밀번호 변경 후에는 자동 로그인 대신 로그인 화면으로 이동시켜 2차 인증을 반드시 거치게 한다.
          kendo.alert('비밀번호 처리가 완료되었습니다. 다시 로그인해 주세요.').bind('close', () => {
            sessionStorage.clear()
            window.location.href = '/login'
          })


        })
      })
    }
  },
}
</script>

<style scoped>
</style>
